import { IManifest } from "./manifest.interface";
import { Marker } from "./marker";

export class Microservice {

	public get name() {
		return this._name;
	}

	public get html() {
		return this._html;
	}

	public get css(): string[] {
		return this._css;
	}

	public get js() {
		return this._js;
	}
	public marker: Marker;
	public manifest: IManifest;
	public isLoaded: boolean;
	private _name: string;
	private _html: string;
	private _css: string[];
	private _js: string[];

	constructor(marker: Marker) {

		this.marker = marker;
		this._css = [];
		this._js = [];
		this.isLoaded = false;
	}

	public setName(name: string) {

		this._name = name;
	}

	public setHtml(html: string) {

		this._html = html;
	}

	public setCss(assets: string[]) {

		this._css = assets;
	}

	public setJs(assets: string[]) {

		this._js = assets;
	}

	public setManifest(manifest: IManifest) {

		this.manifest = manifest;
	}
}
